import { Breakpoints } from './types';

export const breakpointDevices = {
  mobile: 414,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
  lgDesktop: 1440,
};

const setBreakpoint = (breakpoint: 'tablet' | 'laptop' | 'desktop' | number): number | string => {
  if (typeof breakpoint === 'string' && breakpoint in breakpoints) return breakpointDevices[breakpoint];

  return breakpoint;
};

const minBp = (breakpoint: 'tablet' | 'laptop' | 'desktop' | number): string =>
  `@media (min-width: ${setBreakpoint(breakpoint)}px)`;

const maxBp = (breakpoint: 'tablet' | 'laptop' | 'desktop' | number): string =>
  `@media (max-width: ${setBreakpoint(breakpoint)}px)`;

const breakpoints: Breakpoints = {
  ...breakpointDevices,
  minBp,
  maxBp,
};

export default breakpoints;
